import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Package, PackageCheck, PackageX, EyeOff, AlertTriangle, PlusCircle, ListOrdered } from 'lucide-react';
import { apiFetch } from './api';

export default function Dashboard() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-dashboard'],
    queryFn: async () => {
      const r = await apiFetch('/admin/dashboard');
      if (!r.ok) throw new Error('falha');
      return r.json();
    },
  });

  if (isLoading) return <p className="text-sm text-slate-400">Carregando...</p>;

  const cards = [
    { rotulo: 'Produtos cadastrados', valor: data.total, icone: Package, cor: 'bg-mk-blue', testid: 'dash-total' },
    { rotulo: 'Produtos ativos', valor: data.ativos, icone: PackageCheck, cor: 'bg-mk-green', testid: 'dash-ativos' },
    { rotulo: 'Indisponíveis (inativos)', valor: data.inativos, icone: EyeOff, cor: 'bg-slate-400', testid: 'dash-inativos' },
    { rotulo: 'Esgotados', valor: data.esgotados, icone: PackageX, cor: 'bg-mk-red', testid: 'dash-esgotados' },
    { rotulo: 'Estoque baixo', valor: data.estoqueBaixo, icone: AlertTriangle, cor: 'bg-amber-500', testid: 'dash-estoque-baixo' },
  ];
  const extras = [
    { rotulo: 'Produtos em destaque', valor: data.destaques ?? 0, testid: 'dash-destaques' },
    { rotulo: 'Promoções ativas agora', valor: data.promocoes ?? 0, testid: 'dash-promocoes' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-2xl font-extrabold text-slate-900">Visão geral</h1>
      <div className="mt-5 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-5">
        {cards.map((c) => (
          <div key={c.rotulo} data-testid={c.testid} className="rounded-2xl bg-white p-4 shadow-sm">
            <span className={`inline-flex rounded-xl p-2 text-white ${c.cor}`}>
              <c.icone size={18} />
            </span>
            <p className="mt-3 font-heading text-2xl font-extrabold text-slate-900">{c.valor}</p>
            <p className="text-xs font-medium text-slate-500">{c.rotulo}</p>
          </div>
        ))}
      </div>
      <div className="mt-3 grid grid-cols-2 gap-3 sm:gap-4 lg:max-w-md">
        {extras.map((c) => (
          <div key={c.rotulo} data-testid={c.testid} className="rounded-2xl bg-white p-4 shadow-sm">
            <p className="font-heading text-2xl font-extrabold text-mk-blue">{c.valor}</p>
            <p className="text-xs font-medium text-slate-500">{c.rotulo}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 flex flex-wrap gap-3">
        <Link
          data-testid="dash-atalho-novo"
          to="/admin/produtos/novo"
          className="inline-flex items-center gap-2 rounded-full bg-mk-red px-5 py-3 text-sm font-bold text-white shadow-md transition-colors hover:bg-mk-redbright"
        >
          <PlusCircle size={17} /> Cadastrar produto
        </Link>
        <Link
          data-testid="dash-atalho-produtos"
          to="/admin/produtos"
          className="inline-flex items-center gap-2 rounded-full border-2 border-mk-blue px-5 py-3 text-sm font-bold text-mk-blue transition-colors hover:bg-mk-blue hover:text-white"
        >
          <ListOrdered size={17} /> Gerenciar catálogo
        </Link>
      </div>

      <h2 className="mt-8 font-heading text-lg font-extrabold text-slate-900">Atualizados recentemente</h2>
      <div className="mt-3 space-y-2">
        {data.recentes.map((p) => (
          <Link
            key={p.id}
            to={`/admin/produtos/${p.id}`}
            className="flex items-center gap-3 rounded-2xl bg-white p-3 shadow-sm transition-colors hover:bg-blue-50"
          >
            <img src={p.fotos?.[0]} alt="" className="h-11 w-11 rounded-xl object-cover" />
            <span className="min-w-0 flex-1 truncate text-sm font-bold text-slate-800">{p.nome}</span>
            <span className="text-xs text-slate-400">{new Date(p.atualizadoEm).toLocaleDateString('pt-BR')}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
